import { MOBILE_SCREEN_MAX_WIDTH } from '../../../constants/screen'
import { BirdviewState } from '../DashboardBirdview.constants'
import { checkIsBirdviewNormalState } from '../DashboardBirdview.utils.sections'

import { BirdviewCardError } from './BirdviewCardError'
import { BirdviewCardPlaceholder } from './BirdviewCardPlaceholder'
import { BirdviewCardSkeleton } from './BirdviewCardSkeleton'

// The cards sit in a grid that goes single-column on a narrow working area,
// so a header runs out of room by viewport, not by the measured container.
export function checkIsBirdviewCardFooterAction(screenWidth) {
  return screenWidth <= MOBILE_SCREEN_MAX_WIDTH
}

export function checkHasBirdviewCardShowAll({ hasMore, state }) {
  return checkIsBirdviewNormalState(state) && hasMore
}

export function checkHasBirdviewCardAction({ Action, state }) {
  return checkIsBirdviewNormalState(state) && Boolean(Action)
}

export function getBirdviewCardBodyContent({
  children,
  emptyKey,
  state,
  t,
  onRetry,
}) {
  switch (state) {
    case BirdviewState.Loading:
      return <BirdviewCardSkeleton />
    case BirdviewState.Empty:
      return <BirdviewCardPlaceholder>{t(emptyKey)}</BirdviewCardPlaceholder>
    case BirdviewState.Error:
      return <BirdviewCardError onRetry={onRetry} />
    case BirdviewState.Normal:
      return children
    default:
      return null
  }
}
